import * as React from 'react';
import yellowAlert from "src/assets/images/yellow-alert.png";
import { Tooltip } from 'src/component/Tooltip';
import AdminConfig from "@system/config/admin";
import AuthConfig from "@system/config/auth";
import Helper from './Helper';

class ReusableDiv {
    static ShippingMethodDetailRender = () => (
        <div className="col-12 col-sm-12 col-lg-6 col-xl-6">
            <div className="d-flex align-items-center flex-wrap h-100">
                <div className="mb-2 sub-title">SHIPPING METHOD:</div>
                <p className="d-block w-100 text-black">
                    We will ship the items as they become available. Shipping method and freight cost as agreed with your Sales Representative and setup in your terms account.
                </p>
                <p className="text-black">
                    Exact freight amount and VAT will be calculated at the time shipment is processed and will appear on your invoice.
                </p>
            </div>
        </div>
    );

    static checkoutStepTitle = (title) => (
        <div className="checkout-titles d-flex justify-content-between">
            <h2>{title}</h2>
        </div>
    );

    static QuoteHeader = () => (
        <div className="container">
            <div className="pcn-page-head header-container d-flex align-items-center justify-content-between">
                <div className="page-title font-oswald font-light font-30">Quotes</div>
            </div>
            <div className="pcn-line-divider" />
        </div>
    );

    static CheckoutItemInfo = () => (
        <div className="checkout-item-info">
            <h3 className="text-center"><img src={yellowAlert} alt='Hazardous Item' /> HAZARDOUS ITEM</h3>
            <p>Due to restrictions on the transportation of dangerous/hazardous goods, there may be additional transit time on items in this shopping cart. Delivery of other items on your order will be unaffected.</p>
        </div>
    );

    static EstimatedShippingTooltip = () => (
        <div>
            The exact freight amount will be calculated at the time shipment is processed and will appear on your shipment notifications.
        </div>
    );

    static PopupTitle = (title) => (
        <div className="bs5 modal-header border-0">
            <h3 className="modal-title m-auto" id="exampleModalLabel">{title}</h3>
        </div>
    );

    static AdminConsoleHeader = (title, redirect) => (
        <div className='container'>
            <div className="adminconsole-head header-container d-flex align-items-center justify-content-between">
                <div className="page-title font-oswald font-light font-38 text-green" onClick={() => redirect ? window.location.href = AdminConfig.getAdminUserManagementURL() : ''}>Admin Console</div>
            </div>
            <div className="pcn-line-divider"></div>
            <div className="page-title font-oswald font-light font-30">{title}</div>
        </div>
    )
    static dataSheetTooltip = () => (
        <Tooltip position={'right center'}
            opener={() => (
                <span className="lifecycle low-risk lifecycle-not-available"
                    aria-hidden="true"
                    data-toggle="tooltip"
                    data-placement="bottom"
                    data-html="true"
                    data-title="Datasheet not available.">
                    <span>--</span>
                </span>
            )}
            content={() => (
                <>
                    Datasheet not available.
                </>
            )}
        />
    );

    static AvnetCarrierOptionHeader = () => (
        <>

            <p>We will ship the items as they become available. Shipping method and  <br /> freight cost as agreed with your Sales Representative and setup in your <br />
                terms account.</p>
            <p>Exact freight amount and VAT will be calculated at the time shipment is processed and will appear on your invoice.</p>
        </>
    )

    static ContactUsPopUpHeaderText = (message) => (
        <>
            <p className='mb-0 mt-3 mb-2 text-center'>{message}</p>
        </>
    )

    static ContactUsPopUpBodyText = (phone, email) => {
        let contactNo = Helper.valueIsNotNull(phone) ? phone : '00800-412-412-11';
        let emailAddress = Helper.valueIsNotNull(email) ? email : 'OnlineSupportEU@avnet.com';
        return <>
                <p className='mb-0'>Phone: {contactNo}</p>
                <p className='mb-0'>Email: <a className='text-blue2' href={`mailto:${emailAddress}?subject=Customer [Account ${AuthConfig.getAccountNumber()}] from FSP requesting assistance`}><u>{emailAddress}</u></a></p>
            </>
    }

    static CartDisclaimerMessage = () => {
        return <div className="disclaimer bg-grey2 p-4 mb-4 rounded-3 mt-3">
            <p className='mb-0'>
                <strong>
                    Disclaimer
                </strong>
            </p>
            <p>
                According to Article 12 g of EU Regulation No. 2014, 833 (and its further subsequent
                amendments),
                the re-export of Avnet products, meeting the criteria of Annex XL of the same Regulation
                to or for
                use in Russia is prohibited. According to Article 8g of EU Regulation No. 765/2006 (and
                its further
                subsequent amendments), the re-export of Avnet products, meeting the criteria of Annex
                XXX of the
                same regulation to or for use in Belarus is prohibited.
            </p>
            <p>
                Any violation against this prohibition will be reported to the relevant authorities and
                may result
                in termination of our business relationship and/or claims for damages from Avnet.
            </p>
        </div>
    }

}

export default ReusableDiv;